<!--
  Generated template for the ModalPhonePanelPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
    <ion-toolbar>
        <ion-title>Telefon</ion-title>
        <ion-buttons slot="primary">
            <ion-button (click)="dismiss()" color="primary">
                {{ 'CLOSE_BUTTON' | translate }}
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>


<ion-content>
    <phone-call-panel [showHeader]="false" [address]="{test:1}"></phone-call-panel>
</ion-content>
